import { render, staticRenderFns } from "./BranchesEditView.vue?vue&type=template&id=716542ec&scoped=true"
import script from "./BranchesEditView.vue?vue&type=script&lang=js"
export * from "./BranchesEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716542ec",
  null
  
)

export default component.exports